module.exports = __webpack_public_path__ + "img/pethouse05.5d057db5.jpg";